import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { BsChevronRight, BsExclamation } from "react-icons/bs";
import { PiCaretRightBold } from "react-icons/pi";
import Swal from "sweetalert2";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import { emailValidation } from "../../../../../utils/EmailValidation";
import { useHistory } from "react-router-dom";
import styles from "./styles.module.scss";
import Loading from "../../../../home/components/Loading";
import { selectStyle } from "../../../../../components/InputSelectAsync";
import Steps from "../../../components/Steps";
import { expireDateValidation } from "../../../../../utils/expireDateValidation";

const ReverseForm = ({ step, totalSteps, reverseLogistics }) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailOK, setEmailOK] = useState("vazio");
  const [emailError, setEmailError] = useState("");
  const [expireDays, setExpireDays] = useState(7);
  const [expireDaysOK, setExpireDaysOK] = useState("ok");
  const [expireDaysError, setExpireDaysError] = useState("");

  const handleSubmit = e => {
    setLoading(true);
    e.preventDefault();

    const formCanSubmit = fieldsInFormIsAbleToSubmit();
    if (formCanSubmit === false) {
      Swal.fire({
        icon: "warning",
        title: "Validação",
        text: "É necessário que seja preenchidos todos os campos sinalizados."
      });
      setLoading(false);
      return;
    }
    window.localStorage.setItem("brcom:email-logistics-reverse", email);
    window.localStorage.setItem("brcom:expireDays-logistics-reverse", expireDays);

    setLoading(false);
    history.push("/nova-coleta/reverse-send-form");
    return;
  };

  function handleInputEmail(email) {
    handleValidationEmail(email);
    setEmail(email);
  }

  const handleValidationEmail = useCallback(value => {
    const validEmail = emailValidation({
      email: value,
      emptyEmail: "Campo obrigatório",
      incorrectEmail: "Email incorreto"
    });

    setEmailOK(validEmail.status);
    setEmailError(validEmail.message);
  }, []);

  const handleValidationExpireDays = useCallback(value => {
    const validDays = expireDateValidation({
      days: value,
      emptyMsg: "Campo obrigatório!",
      incorrectMsg: "O prazo deve ser entre 1 e 30 dias!"
    });

    setExpireDaysOK(validDays.status);
    setExpireDaysError(validDays.message);
  }, []);

  function handleInputExpire(days) {
    handleValidationExpireDays(days);
    setExpireDays(days);
  }

  const fieldsInFormIsAbleToSubmit = useCallback(() => {
    let result = true;

    handleValidationEmail(email);
    handleValidationExpireDays(expireDays);

    if (emailOK !== "ok") {
      return false;
    }

    if (expireDaysOK !== "ok") {
      return false;
    }

    return result;
  }, [
    emailOK,
    expireDaysOK,
    email,
    expireDays,
    handleValidationEmail,
    handleValidationExpireDays
  ]);

  return (
    <>
      <Loading loading={loading} />

      <main className={styles.main}>
        <div className={styles.container}>
          <div className={styles.title}>
            <h2>Dados da Logística Reversa</h2>
          </div>
          <Steps step={step} total={totalSteps} />

          <p className={styles.info}>
            Por gentileza, informar o email do remetente para que seja enviado o
            código de autorização assim que o mesmo for gerado
          </p>
          <form className={styles.form}>
            <div className={styles.formContent}>
              <div className={styles.inputsContainer}>
                <div className={styles.inputContainer}>
                  <div className={styles.input} role={emailOK}>
                    <input
                      type="text"
                      name="email"
                      placeholder="Digite o email"
                      onChange={e => handleInputEmail(e.target.value)}
                      value={email}
                    />
                    <AiOutlineCheck className={styles.check} role={emailOK} />
                    <BsExclamation className={styles.danger} role={emailOK} />
                  </div>
                  <p className={styles.error}>{emailError}</p>
                </div>
                <div className={styles.inputContainer}>
                  <p className={styles.info}>
                    Prazo máximo para postagem do objeto {"(dias corridos)"}
                  </p>
                  <div className={styles.input} role={expireDaysOK}>
                    <input
                      type="text"
                      name="expireDays"
                      placeholder="Prazo entre 1 e 30 dias"
                      onChange={e => handleInputExpire(e.target.value)}
                      value={expireDays}
                    />
                    <AiOutlineCheck className={styles.check} role={expireDaysOK} />
                    <BsExclamation className={styles.danger} role={expireDaysOK} />
                  </div>
                  {expireDaysError && <p className={styles.error}>{expireDaysError}</p>}
                </div>
              </div>
            </div>
            <div className={styles.buttonsContainer}>
              <div className={styles.buttonContainer}>
                <button type="submit" onClick={handleSubmit}>
                  Próximo passo
                  <PiCaretRightBold />
                </button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </>
  );
};

export { ReverseForm };
